import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./CreateEnvironment.module.css";
import ButtonCta1 from "../button/ButtonCta1";
import { BASE_URL, toastConfig } from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { CustomTextField } from "../../helpers/helper";
import { getAllEnvironment } from "../../reduxSlices/environmentSlice";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import {
  validateName,
  validateId,
  validateDbServer,
  validateDbName,
} from "../../helpers/helper";
import { isValid } from "date-fns";

const service = new Service();

const CreateEnvironment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { environmentId } = useParams();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [showPassword, setShowPassword] = useState({
    clientSecret: false,
    databaseUserPassword: false,
  });

  const [environment, setEnvironment] = useState({
    environmentId: "",
    environmentName: "",
    envSyncUser: "",
    envSynPassword: "",
    envAccessToken: "access_token",
    envRefreshToken: "refresh_token",
    clientId: "",
    clientSecret: "",
    databaseServer: "",
    databaseName: "",
    databaseUserName: "",
    databaseUserPassword: "",
    organization: {
      organizationId: "",
      organizationName: "",
    },
    isValidId: false,
    isValidName: false,
    isValidServer: false,
    isValiddbName: false,
    isValidUserName: false,
    isValidPassword: false,
  });
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const buttonAction = useSelector((state) => state?.header?.buttonAction);
  const allEnvironment = useSelector(
    (state) => state.environment.allEnvironment
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const areInputsFilled = () => {
    return (
      environment?.organization?.organizationName &&
      environment?.environmentId?.trim() !== "" &&
      environment?.environmentName?.trim() !== "" &&
      environment?.databaseServer?.trim() !== "" &&
      environment?.databaseName?.trim() !== "" &&
      environment?.databaseUserName?.trim() !== "" &&
      environment?.databaseUserPassword?.trim() !== ""
    );
  };
  const inputFilled = areInputsFilled();

  const getEnvironmentData = async () => {
    const obj = {
      searchText: "",
    };
    await dispatch(getAllEnvironment(obj));
  };

  useEffect(() => {
    if (!environmentId) return;
    getEnvironmentData();
  }, [environmentId]);

  useEffect(() => {
    if (!allEnvironment && !environmentId) return;
    if (environmentId) {
      const filterEnvironment = allEnvironment.filter(
        (item) => item.environmentId === environmentId
      );
      console.log("filterEnvironment", filterEnvironment);
      filterEnvironment?.map((item) => setEnvironment({ ...item }));
    }
  }, [environmentId, allEnvironment]);

  useEffect(() => {
    console.log("environment>>>>", environment);
  }, [environment]);

  useEffect(() => {
    console.log("inputFilled>>>>", inputFilled);
    if (!environmentId) {
      dispatch(setAddButtonDisabled(inputFilled));
    } else {
      dispatch(setUpdateButtonDisabled(inputFilled));
    }
  }, [inputFilled]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: !environmentId ? "add-environment" : "edit-environment",
        title: !environmentId ? "Add Environment" : "Edit Environment",
        subTitle: !environmentId
          ? "Please select the organisation and fill all the mandatory details to add environment"
          : "Please update environment details if there are any discrepancies",
      })
    );
  }, []);

  useEffect(() => {
    if (
      (buttonAction.page === "add-environment" &&
        buttonAction.action === "add") ||
      (buttonAction.page.includes("edit-environment") &&
        buttonAction.action === "update")
    ) {
      console.log("buttonAction called");
      handleSubmit();
    }
    if (
      (buttonAction.page === "add-environment" &&
        buttonAction.action === "cancel") ||
      (buttonAction.page.includes("edit-environment") &&
        buttonAction.action === "cancel")
    ) {
      console.log("buttonAction called");
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  useEffect(() => {
    const fetchOrganization = async () => {
      let url = `/api/Organization/OrganizationMaster`;
      const user_token = localStorage.getItem("bb_access_token");
      try {
        let data = await service.newGetApi(url, {}, user_token);
        let resp = data.data;
        console.log("resp", resp);
        setOrganizationOptions(resp);
      } catch (err) {
        console.log(err);
      }
    };
    fetchOrganization();
  }, []);

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setEnvironment({ ...environment, [name]: value });
  };

  const handleInputFocus = () => {
    if (!environmentId) return;
    dispatch(setUpdateButtonDisabled(inputFilled));
  };

  const handleAutoCompleteChange = (name, value) => {
    setEnvironment((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleTogglePasswordVisibility = (name, value) => {
    setShowPassword((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGoBack = () => {
    navigate(-1);
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!environmentId) {
      createEnvironment();
    } else {
      updateEnvironment();
    }
  };

  const createEnvironment = async () => {
    if (
      environment.isValidName &&
      environment.isValidId &&
      environment.isValidServer &&
      environment.isValiddbName &&
      environment.isValidUserName &&
      environment.isValidPassword
    ) {
      setLoader(true);
      let url = `/api/Environment/AddEnvironment`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPostApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          setLoader(false);
          toast.success("New environment has been added", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/environments");
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    } else {
      setIsButtonClicked(true);
    }
  };

  const updateEnvironment = async () => {
    if (
      environment.environmentId &&
      environment.isValidName &&
      environment.isValidId &&
      environment.isValidServer &&
      environment.isValiddbName &&
      environment.isValidUserName &&
      environment.isValidPassword
    ) {
      setLoader(true);
      let url = `/api/Environment/UpdateEnvironment?environmentId=${environment?.environmentId}`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPutApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          toast.success("Environment details has been updated", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/environments");
          setLoader(false);
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    } else {
      setIsButtonClicked(true);
    }
  };

  const prepareOrganisationData = () => {
    return {
      environmentId: environment.environmentId,
      environmentName: environment.environmentName,
      envAccessToken: environment.envAccessToken,
      envRefreshToken: environment.envRefreshToken,
      databaseServer: environment.databaseServer,
      databaseName: environment.databaseName,
      databaseUserName: environment.databaseUserName,
      databaseUserPassword: environment.databaseUserPassword,
      organization: environment.organization,
    };
  };

  useEffect(() => {
    let updatedEnvironment = { ...environment };

    updatedEnvironment.isValidName = validateName(environment.environmentName);
    updatedEnvironment.isValidId = validateId(environment.environmentId);
    updatedEnvironment.isValidServer = validateDbServer(
      environment.databaseServer
    );
    updatedEnvironment.isValiddbName = validateDbName(environment.databaseName);
    updatedEnvironment.isValidUserName = validateId(
      environment.databaseUserName
    );
    updatedEnvironment.isValidPassword = validateId(
      environment.databaseUserPassword
    );

    setEnvironment(updatedEnvironment);
  }, [
    environment.environmentName,
    environment.environmentId,
    environment.databaseServer,
    environment.databaseName,
    environment.databaseUserName,
    environment.databaseUserPassword,
  ]);

  const prepData = prepareOrganisationData();
  console.log("prepData>>>", prepData);

  const getOrgLabel = (option) => option?.organizationName;

  if (loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "32px 32px 16px 0",
          // height: "calc(100vh - 340px)",
          // overflowY: "auto",
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "20px", width: "520px" },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Organisation<sup style={requiredAr}>*</sup>
            </label>
            {/* <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={organizationOptions}
              value={environment.organization || null}
              onChange={(e, value) =>
                handleAutoCompleteChange("organization", value)
              }
              getOptionLabel={(option) => option?.organizationName || ""}
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  placeholder="Select the organisation..."
                  onFocus={handleInputFocus}
                />
              )}
            /> */}
            <CustomAutocomplete
              options={organizationOptions}
              value={environment.organization}
              onChange={(e, value) =>
                handleAutoCompleteChange("organization", value)
              }
              getOptionLabel={getOrgLabel}
              onFocus={handleInputFocus}
              placeholder="Select the organisation..."
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <label style={labelStyle}>
                Environment Id<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                disabled={environmentId}
                placeholder="Blackbaud environment Id..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="environmentId"
                sx={{
                  width: "240px",
                  backgroundColor: environmentId ? "#efefef" : "#fff",
                }}
                value={environment.environmentId}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
              {environment?.environmentId &&
                !environment?.isValidId &&
                isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Text is not valid.
                  </Typography>
                )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Environment Name<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter environment name..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="environmentName"
                sx={{ width: "240px" }}
                value={environment.environmentName}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
              {environment?.environmentName &&
                !environment?.isValidName &&
                isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Text is not valid.
                  </Typography>
                )}
            </Box>
          </Box>
          {/* <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label style={labelStyle}>
                Sync Username<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter sync username..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="envSyncUser"
                sx={{ width: "240px" }}
                value={environment.envSyncUser}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Sync Password<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter sync password..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="envSynPassword"
                sx={{ width: "240px" }}
                value={environment.envSynPassword}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Client Id<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter client id..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="clientId"
                sx={{ width: "240px" }}
                value={environment.clientId}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Client Secret<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter client secret..."
                id="outlined-basic"
                variant="outlined"
                type={showPassword?.clientSecret ? "text" : "password"}
                name="clientSecret"
                sx={{ width: "240px" }}
                value={environment.clientSecret}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          handleTogglePasswordVisibility(
                            "clientSecret",
                            !showPassword.clientSecret
                          )
                        }
                        edge="end"
                      >
                        {showPassword?.clientSecret ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ marginTop: "27px", marginLeft: "40px" }}>
              <ButtonCta1
                text="Verify Credential"
                onClick={connectClick}
                variant="outlined"
                disabled={!verifyInputsFilled()}
                bgColor="#fff"
                color="#f7954c"
                width="170px"
                height="48px"
              />
            </Box>
          </Box> */}
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <label style={labelStyle}>
                Database Server<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter database server..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="databaseServer"
                sx={{ width: "240px" }}
                value={environment.databaseServer}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
              {environment?.databaseServer &&
                !environment?.isValidServer &&
                isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Text is not valid.
                  </Typography>
                )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Database Name<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter database name..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="databaseName"
                sx={{ width: "240px" }}
                value={environment.databaseName}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
              {environment?.databaseName &&
                !environment?.isValiddbName &&
                isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Text is not valid.
                  </Typography>
                )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Database Username<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter database username..."
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="databaseUserName"
                sx={{ width: "240px" }}
                value={environment.databaseUserName}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
              />
              {environment?.databaseUserName &&
                !environment?.isValidUserName &&
                isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Text is not valid.
                  </Typography>
                )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <label style={labelStyle}>
                Database Password<sup style={requiredAr}>*</sup>
              </label>
              <CustomTextField
                placeholder="Enter database password..."
                id="outlined-basic"
                variant="outlined"
                type={showPassword.databaseUserPassword ? "text" : "password"}
                name="databaseUserPassword"
                sx={{ width: "240px" }}
                value={environment.databaseUserPassword}
                onChange={handleOrganizationChange}
                onFocus={handleInputFocus}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          handleTogglePasswordVisibility(
                            "databaseUserPassword",
                            !showPassword.databaseUserPassword
                          )
                        }
                        edge="end"
                      >
                        {showPassword?.databaseUserPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {environment?.databaseUserPassword &&
                !environment?.isValidPassword &&
                isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Text is not valid.
                  </Typography>
                )}
            </Box>
          </Box>
        </Box>
      </div>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default CreateEnvironment;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};
